<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo skupino:
    </h2>

    <CategoryForm
      @save="save"
      @cancel="cancel"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CategoryForm from '@/components/CategoryForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    CategoryForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('categories', ['saveItem']),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyCategories'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyCategories' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
